"use strict";

exports.__esModule = true;
exports.PerfectScrollbar = exports.NativeScrollArea = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _reactPerfectScrollbar = _interopRequireDefault(require("react-perfect-scrollbar"));

require("react-perfect-scrollbar/dist/css/styles.css");

var _browser = _interopRequireDefault(require("../../../helpers/browser"));

var _polished = require("polished");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const StyledPerfectScrollbar = (0, _styledComponents.default)(({
  renderNativeScrollbars,
  forceNativeScroll,
  disableNativeScroll,
  useNativeScrollbars,
  useNativeScollbarsInIE,
  children,
  ...otherProps
}) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactPerfectScrollbar.default, { ...otherProps,
  children: children
}))`
    position: relative;
    display: block;
    width: 100%;
    height: 100%;
    overflow: auto;

    &::-webkit-scrollbar {
        width: 8px;
        height: 8px;
    }

    &::-webkit-scrollbar-thumb {
        width: 8px;
        border-radius: 4px;
        background-color: ${({
  theme
}) => theme.colors.scrollArea.scrollbar};
    }

    &:hover {
        &::-webkit-scrollbar-thumb {
            background-color: ${({
  theme
}) => theme.colors.scrollArea.hover.scrollbar};
        }
    }

    ${_browser.default.isIOS() && (0, _styledComponents.css)`
        -webkit-overflow-scrolling: touch;
    `}


    &.ps {
        overflow: hidden;
        position: relative;

        > .ps__rail-y,
          .ps__rail-y:hover,
          .ps__rail-y--clicking,
          .ps__rail-x,
          .ps__rail-x:hover,
          .ps__rail-x--clicking {
            background-color: transparent;
            opacity: 1;
            display: block;
    
            > .ps__thumb-y {
                width: 8px;
                outline: none;
                box-shadow: none;
                background-color: ${({
  theme
}) => theme.colors.scrollArea.scrollbar};

                &:focus {
                    background-color: ${({
  theme
}) => (0, _polished.lighten)(0.3, theme.colors.scrollArea.scrollbar)};
                }
            }
    
            > .ps__thumb-x {
                height: 8px;
                outline: none;
                box-shadow: none;
                background-color: ${({
  theme
}) => theme.colors.scrollArea.scrollbar};

                &:focus {
                    background-color: ${({
  theme
}) => (0, _polished.lighten)(0.3, theme.colors.scrollArea.scrollbar)};
                }
            }
        }
    }
    
    &.ps:hover {
        > .ps__rail-y,
          .ps__rail-y:hover,
          .ps__rail-y--clicking,
          .ps__rail-x,
          .ps__rail-x:hover,
          .ps__rail-x--clicking {
            opacity: 1;
            > .ps__thumb-y, > .ps__thumb-x {
                background-color: ${({
  theme
}) => theme.colors.scrollArea.hover.scrollbar};

                &:focus {
                    background-color: ${({
  theme
}) => (0, _polished.lighten)(0.3, theme.colors.scrollArea.scrollbar)};
                }
            }
        }
    }
    
`;
exports.PerfectScrollbar = StyledPerfectScrollbar;
const NativeScrollArea = _styledComponents.default.div`
    position: relative;
    display: block;
    width: 100%;
    height: 100%;
    overflow: auto !important;

    ${_browser.default.isIOS() && (0, _styledComponents.css)`
        -webkit-overflow-scrolling: touch;
    `}

    &::-webkit-scrollbar {
        width: 8px;
        height: 8px;
    }

    &::-webkit-scrollbar-thumb {
        width: 8px;
        border-radius: 4px;
        background-color: ${({
  theme
}) => theme.colors.scrollArea.scrollbar};
    }

    &:hover {
        &::-webkit-scrollbar-thumb {
            background-color: ${({
  theme
}) => theme.colors.scrollArea.hover.scrollbar};
        }
    }
`;
exports.NativeScrollArea = NativeScrollArea;